<template>
    <div>
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" v-if="isChecked">
            <rect width="16" height="16" rx="3" fill="#206CFF" />
            <path
                d="M6.46154 11.0686L5.90475 11.5711L6.46154 12.1881L7.01832 11.5711L6.46154 11.0686ZM3.44321 8.84356L5.90475 11.5711L7.01832 10.5661L4.55679 7.83859L3.44321 8.84356ZM7.01832 11.5711L12.5568 5.43412L11.4432 4.42916L5.90475 10.5661L7.01832 11.5711Z"
                fill="white"
            />
        </svg>

        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" v-else>
            <rect x="0.5" y="0.5" width="15" height="15" rx="2.5" fill="white" />
            <rect x="0.5" y="0.5" width="15" height="15" rx="2.5" stroke="#C8D0DD" />
        </svg>
    </div>
</template>
<script>
export default {
    name: "SOCheckBox",
    props: {
        isChecked: {
            type: Boolean,
            default: false,
        },
    },
};
</script>
